<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Title Settings Table</h6>
      </div>

    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{ alertstatus }}</strong> {{ alerttext }}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Title
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Sub Title
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Action
              </th>

            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>{{ item.title }}</td>
              <td>{{ item.sub_title }}</td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i
                    class="fa fa-edit"></i></button>
                <!-- <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i class="fa fa-trash"></i></button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item prev :disabled="currentPage === 1" @click="prevPage" />

          <!-- Page Numbers -->
          <argon-pagination-item v-for="page in totalPages" :key="page" :label="String(page)"
            :active="currentPage === page" @click="setPage(page)" />

          <!-- Next Page Button -->
          <argon-pagination-item next :disabled="currentPage === totalPages" @click="nextPage" />
        </argon-pagination>
      </div>

      <div :class="showModal == true ? 'modal-backdrop' : ''"></div>
      <div class="modal fade" :class="showModal == true ? 'show' : ''" tabindex="-1" aria-labelledby="modalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add'">Add New title</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit title</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" class="form-control" v-model="formData.title" id="title" required>
                </div>
                <div class="mb-3">
                  <label for="sub_title" class="form-label">Sub Title</label>
                  <input type="text" class="form-control" v-model="formData.sub_title" id="sub_title" required>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  data() {
    return {
      titleList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage: 20,
      sortOrder: 'asc',
      searchQuery: '',
      showModal: false, // Controls modal visibility
      formData: {
        title: '',
        sub_title: '',
      },
      errors: {
        no_wa: null,
      },
      method: 'add',
      alertstatus: null,
      alerttext: null
    };
  },
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonAlert,
  },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchtitleList();
  },
  computed: {
    totalItems() {
      return this.titleList.length;
    },
    paginatedData() {
      return this.titleList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchtitleList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/title_parent",
        headers: {
          'Authorization': 'Bearer ' + access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {
          if (response.data?.message == 'success') {
            this.titleList = response.data.data; // Assign banner_list to local data
            this.totalPages = 1
          } else {
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchtitleList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchtitleList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchtitleList();
    },
    updateItemsPerPage() {
      this.fetchtitleList();
    },
    updatesoftby() {
      this.fetchtitleList();
    },
    cari() {
      this.fetchtitleList();
    },
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData = {
        title_name: '',
      };
      this.method = 'add';
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    handleFileUpload(event) {
      this.formData.file = event.target.files[0]; // Capture the file
    },
    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      var data = {};
      var config = {};
      data = {
        "title": this.formData.title,
        "sub_title": this.formData.sub_title,
      }
      config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: 'https://api-profile.productscala.online/admin/title_parent/' + this.formData.id,
        headers: {
          'Authorization': 'Bearer ' + access_token // Replace with the actual token
        },
        data: data,
      };


      try {
        const response = await axios.request(config);
        if (response.data?.message == 'success') {
          this.fetchtitleList();
          if (this.method == 'add') {
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          this.closeModal(); // Close modal after successful submission
        } else {
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.message
        this.alertstatus = 'danger';
        this.alerttext = err
        console.error("Error fetching data:", error);
      }
    },

    edit(item) {
      this.formData = {
        title: item.title,
        sub_title: item.sub_title,
        id: item.id
      };
      this.showModal = true;
      this.method = 'edit';
    },
    validateWhatsAppNumber() {
      const waRegex = /^(\+62)[8][1-9][0-9]{6,11}$/; // Regex untuk memvalidasi nomor WA
      if (!this.formData.no_wa) {
        this.errors.no_wa = "Nomor WhatsApp harus diisi.";
      } else if (!waRegex.test(this.formData.no_wa)) {
        this.errors.no_wa =
          "Nomor WhatsApp tidak valid. Pastikan diawali dengan +62.";
      } else {
        this.errors.no_wa = null;
      }
    },

  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block;
  /* Override display to block */
}

.modal-backdrop {
  opacity: 50%;
}
</style>